import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { TFunction } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Divider } from '@lyearn/ui';
import ProviderComponent from '@/components/Provider';
import AboutComponent from '@/modules/corporate/components/DetailPageComponents/AboutCourse';
import Skills from '@/modules/corporate/components/DetailPageComponents/Skills';

import Certificate from '../../components/Certificate';
import { QuizDetailsContentFragment } from '../../graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '../../graphql/fragments/generated/QuizDetailsPerformance';

interface Params {
  t: TFunction;
  content: QuizDetailsContentFragment;
  isAdminRoute?: boolean;
  responsive?: boolean;
  quizPerformance?: QuizDetailsPerformanceFragment;
}
const responsiveCertificateStyles = { height: 142, width: 202 };

const getQuizDetailsSections = ({
  content,
  t,
  isAdminRoute,
  responsive,
  quizPerformance,
}: Params) => {
  const components = [
    {
      component: (
        <Skills
          key="skills"
          className={cn({ 'px-4': responsive })}
          skills={content.skills}
          title={t('QuizPlayer:Details.SkillsTitle')}
        />
      ),
      enabled: Boolean(content.skills?.length),
    },
    {
      component: (
        <>
          <Divider className={cn('mb-56 bg-divider', { hidden: !responsive })} />
          <AboutComponent
            key="about"
            className={cn({ 'mb-56 px-8': responsive })}
            description={content.description}
            title={t('QuizPlayer:Details.AboutQuiz')}
          />
        </>
      ),
      enabled: Boolean(content.description),
    },
    {
      component: (
        <>
          <Divider className={cn('mb-56 bg-divider', { hidden: !responsive })} />
          <Certificate
            className="xs:px-4"
            externalCertificateDimensions={responsive ? responsiveCertificateStyles : undefined}
            quiz={content}
            quizPerformance={quizPerformance}
          />
        </>
      ),
      enabled: Boolean(content.certificateTemplate?.preview.url),
    },
    {
      component: <ProviderComponent workspace={content.sharedByWorkspace!} />,
      enabled: !!content.sharedByWorkspace && !isAdminRoute,
    },
  ];

  return getEnabledItems(components).map((item) => item.component);
};

export default getQuizDetailsSections;
